import styled from 'styled-components';
import { Button } from '@unimed-fesp/components';

import theme from '../../styles/theme';

export const Container = styled.div`
  width: 1038px;
  border-radius: 5px;
  background: ${theme.bgWhite} 0% 0% no-repeat padding-box;
  margin: 28px auto;
  padding: 28px;
`;

export const Title = styled.h1`
  font: normal normal bold 24px/16px 'unimed_slabbold';
  color: ${theme.titleGray};
  margin-bottom: 28px;
  letter-spacing: 0.48px;
`;

export const Text = styled.p`
  font: normal normal normal 15px/23px Calibri;
  letter-spacing: 0.6px;
  color: ${theme.colorGray};
  max-width: 700px;

  @media print {
    text-align: left;
    padding-right: 30px;
  }
`;

export const Assinatura = styled.div`
  border-top: 1px solid ${theme.colorGray};
  font: normal normal normal 15px/23px Calibri;
  letter-spacing: 0.6px;
  color: ${theme.colorGray};
  padding-top: 5px;
  margin-top: 100px;
  max-width: 40%;
`;

export const Copy = styled.span`
  font: normal normal normal 10px/13px Calibri;
  color: ${theme.grey};
  position: absolute;
  bottom: 10px;
`;

export const ButtonImprimir = styled(Button)`
  flex-direction: row-reverse;
`;

export const ImageANS = styled.img`
  display: block;
  max-width: 120px;
  margin-top: 28px;
`;
